import load from "./wasm";
import type { WASM_MODULE } from "./type";
export * from "./cube";
export * from "./cube-map";

let wasmModule: undefined | WASM_MODULE;
export const init = () => {
  return load();
};

export const solve = async (input: string): Promise<string> => {
  if (!wasmModule) {
    wasmModule = await load();
  }
  const solve_cube = wasmModule.cwrap("solve_cube", "string", ["string"]);
  const output = solve_cube(input);
  return output.trim();
};
